import {secureFetch} from "./authService";
import {API_BASE_URL} from "./constants";

const UPDATE_CLIENT_SERVICE_URL = API_BASE_URL + '/update/client';

export function getLatestClientUpdate() {
    return secureFetch(UPDATE_CLIENT_SERVICE_URL, {
        method: 'GET',
    });
}

export function saveNewVersion(data) {
    return secureFetch(UPDATE_CLIENT_SERVICE_URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
}


// WEBPACK FOOTER //
// ./src/helpers/clientUpdateService.js